<!-- Page Content -->
<main id="mainBodyContainer" class="container">
    <div class="col-md-8 col-12 mx-auto my-5 px-3">
        <h1 class="mb-3 mt-0">APA's Demographic Questionnaire</h1>
  
        <!-- ******************** BEGIN: MAIN PAGE CONTENT ******************** -->
        <div class="mb-0">
            <div id="submitted" class="row">
                <div class="col-sm-12 py-3">
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 px-4 pt-2">
                                    <p>
                                        Thank you for helping to further our ongoing Equity, Diversity, and Inclusion efforts. We appreciate the time you have taken to answer this questionnaire.
                                    </p>
                                    <p>
                                        The information you have provided is securely housed in an APA database and will only be reported on as de-identified, aggregate data. Collecting this information allows APA to better measure the Journals program’s progress towards the commitments made in <a href="https://www.apa.org/about/apa/equity-diversity-inclusion/framework" target="_blank">APA’s EDI Framework</a> and in the organization’s <a href="https://www.apa.org/about/policy/dismantling-systemic-racism" target="_blank">resolution on psychology’s role in dismantling systemic racism</a>. 
                                    </p>
                                    <p><strong>You can now close this window.</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </main>
  
  